import { render, staticRenderFns } from "./ProductPhotos.vue?vue&type=template&id=052bbf36"
import script from "./ProductPhotos.vue?vue&type=script&lang=js"
export * from "./ProductPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports